import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Download } from 'lucide-react';
import { api } from '../lib/api';

export default function Audit() {
  const [search, setSearch] = useState('');
  const [action, setAction] = useState('');
  const [actor, setActor] = useState('');
  const params: Record<string, string> = {};
  if (search) params.search = search;
  if (action) params.action = action;
  if (actor)  params.actor = actor;

  const { data } = useQuery({
    queryKey: ['audit', params],
    queryFn: () => api.audit.list(params),
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Audit Log</h1>
      <div className="flex gap-3 flex-wrap items-end">
        <div className="flex-1 min-w-48">
          <label className="block text-sm text-textSecondary mb-1">Search</label>
          <input className="input" value={search} onChange={e => setSearch(e.target.value)} placeholder="user, IP, object..." />
        </div>
        <div>
          <label className="block text-sm text-textSecondary mb-1">Action</label>
          <select className="input" value={action} onChange={e => setAction(e.target.value)}>
            <option value="">All</option>
            {['create','update','delete','login','logout','export','transcribe','purge'].map(a => <option key={a}>{a}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm text-textSecondary mb-1">Actor</label>
          <input className="input" value={actor} onChange={e => setActor(e.target.value)} />
        </div>
        <button onClick={() => api.audit.exportCsv(params)} className="btn-primary inline-flex items-center gap-2">
          <Download size={14} /> Export CSV
        </button>
      </div>
      <div className="card p-0 overflow-hidden">
        <table className="table">
          <thead>
            <tr>
              <th>Time</th>
              <th>User</th>
              <th>IP</th>
              <th>Action</th>
              <th>Type</th>
              <th>Name</th>
              <th>Changes</th>
            </tr>
          </thead>
          <tbody>
            {data?.rows?.map((r: any) => (
              <tr key={r.audit_id} className="hover:bg-elevated">
                <td className="text-xs">{new Date(r.occurred_at).toLocaleString()}</td>
                <td>{r.actor_user}</td>
                <td className="font-mono text-xs">{r.actor_ip}</td>
                <td>{r.action}</td>
                <td>{r.object_type}</td>
                <td className="text-xs max-w-xs truncate">{r.object_name}</td>
                <td className="text-xs max-w-md truncate font-mono">{r.new_data ? JSON.stringify(r.new_data) : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!data?.rows?.length && <div className="p-6 text-center text-textSecondary">No audit entries.</div>}
      </div>
      {data?.total !== undefined && <div className="text-sm text-textSecondary">{data.total} total.</div>}
    </div>
  );
}
